import { safeLs } from 'shared/storages';

import { KeyClockAuthService } from '../KeyCloakAuthService';

import { KeycloakConfig, KeycloakTokens } from '../types';

import { KEYCLOAK_TOKENS } from '../constants';

export const refreshKeycloakToken = (keycloakConfig?: KeycloakConfig) => {
  const refreshToken = async () => {
    const keycloakTokens = safeLs.get<KeycloakTokens, 'sync'>(KEYCLOAK_TOKENS, {
      parse: true,
      type: 'sync',
    });

    if (keycloakTokens?.refreshToken) {
      return await KeyClockAuthService.refreshTokens();
    }

    if (keycloakConfig?.allowAnonymous) return Promise.reject();
  };

  return {
    refreshToken,
  };
};
